import {ComponentProps} from 'react';

import {Icon} from 'components/Icon/Icon';

export const CART_ORDER_FORM_ID = 'cartOrderForm';

export enum PaymentOptionType {
    Cash = 'cash',
    Invoice = 'invoice',
    Card = 'card',
    Credit = 'credit',
}

export const ORDER_PAYMENT_OPTIONS: Array<{
    id: PaymentOptionType;
    title: string;
    iconName: ComponentProps<typeof Icon>['name'];
}> = [
    {
        id: PaymentOptionType.Invoice,
        title: 'Безналичная оплата',
        iconName: 'docFill',
    },
    {id: PaymentOptionType.Cash, title: 'Оплата наличными', iconName: 'coin'},
    {
        id: PaymentOptionType.Card,
        title: 'Оплата картой на сайте',
        iconName: 'card',
    },
    {id: PaymentOptionType.Credit, title: 'Купить в кредит', iconName: 'bank'},
];
